import {UIProps} from "../../types";
import {LoadingIcon} from "../../assets/icon";

export default function Switch({
    size="default",
    checked=false,
    loading=false,
    onChange,
    className,
    disabled=false,
    ...props
                               }:{
    size?:"default"|"sm",
    checked?:boolean,
    loading?:boolean,
    disabled?:boolean,
    onChange?:(checked:boolean)=>void,
}&UIProps){
    const onClick = ()=>{
        if(!disabled && !loading){
            onChange && onChange(!checked)
        }
    }
    return <div onClick={onClick} className={`matchid-switch matchid-switch-${size} ${checked ? "matchid-switch-checked":""} ${disabled ? "matchid-switch-disabled":""} ${loading ? "matchid-switch-loading":""}`} {...props}>

        {
            loading ?
                <LoadingIcon className="matchid-switch-loading-icon" size={size=="default"?24:18} color="var(--matchid-swicth-loading-color)"/> :
                <div className={"matchid-switch-ball"}></div>
        }
    </div>
}